import CivilClusterPage from "./seo/CivilClusterPage";

export default function SsspGeneratorNZ() {
  return <CivilClusterPage pageKey="sssp" />;
}
